// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"241abc8c","240":"1cfe20f1","254":"31d6cfe0","392":"31d6cfe0","550":"20482a57","740":"3e6aa051"}[chunkId] + ".chunk.css";
};